import React from "react";
import { Icon } from "@iconify/react/dist/iconify.js";

/**
 * Linha de tabela com um spinner centrado, usada enquanto os dados carregam.
 * Substitui o antigo texto simples "A carregar..." por um indicador visual.
 */
const TableLoadingRow = ({ colSpan, label }) => (
  <tr>
    <td colSpan={colSpan} className='text-center py-32'>
      <Icon icon='svg-spinners:ring-resize' className='text-primary-600' style={{ fontSize: 32 }} />
      <div className='text-secondary-light mt-8'>{label}</div>
    </td>
  </tr>
);

export default TableLoadingRow;
